export function FeedbackButton({ onClick }: { onClick(): void }) {
  return <button className="feedback-box" type="button" onClick={onClick}>
    <span><strong>How can we make this better?</strong><span className="feedback-description">Help shape One Step Ahead. Two quick questions.</span></span>
    <span className="feedback-arrow" aria-hidden="true">↗</span>
  </button>;
}
